import { render, staticRenderFns } from "./RegisterDiscard.vue?vue&type=template&id=cb6d280c&scoped=true"
import script from "./RegisterDiscard.vue?vue&type=script&lang=ts"
export * from "./RegisterDiscard.vue?vue&type=script&lang=ts"
import style0 from "./RegisterDiscard.vue?vue&type=style&index=0&id=cb6d280c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d280c",
  null
  
)

export default component.exports